import { render } from "./DonationHeader.vue?vue&type=template&id=311daa32&scoped=true"
import script from "./DonationHeader.vue?vue&type=script&lang=js"
export * from "./DonationHeader.vue?vue&type=script&lang=js"

import "./DonationHeader.vue?vue&type=style&index=0&id=311daa32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311daa32"]])

export default __exports__